export const isDefined = <T>(value: T): value is Exclude<T, null | undefined> => {
  return value !== undefined && value !== null;
};
